$(function () {    
    var aTags = document.getElementsByTagName('a');

    for (var i = 0; i < aTags.length; i++)
    {
        if (aTags[i].children.length === 0 &&
            aTags[i].getAttribute("href") != null &&
            aTags[i].getAttribute("href").toLowerCase().substring(0, 4) === "http" &&
            aTags[i].getAttribute("href").toLowerCase().indexOf("warnersllp.com") === -1
            )
        {
            $(aTags[i]).addClass("externalLink");
        }
    }
});

